import { ShieldAlert } from "lucide-react";
import { GoodCheck } from "@/components/GoodCheck";

const FIELDS = [
  ["warrantor_identified", "Who provides the warranty (warrantor)"],
  ["parts_labour_specified", "Parts & labour covered"],
  ["time_distance_limits", "Time & distance limits"],
  ["obligations_specified", "Purchaser & seller obligations"],
];

// Shows only when the dealer is providing a warranty on the vehicle. RED (-15) when any required term is
// missing; green when the warranty terms are fully spelled out.
export const WarrantyDetailsCard = ({ notice, details }) => {
  if (!notice) return null;
  const bad = notice.status === "NONCOMPLIANT";
  const missing = new Set(notice.missing || []);
  const style = bad
    ? { text: "text-destructive", bg: "bg-destructive-soft", border: "border-destructive/40", badge: "−15 points" }
    : { text: "text-success", bg: "bg-success-soft", border: "border-success/40", badge: "Complete" };

  return (
    <div
      data-testid="warranty-details-card"
      data-status={notice.status}
      className={`rounded-xl border ${style.border} ${style.bg} p-5`}
    >
      <div className="flex items-start gap-3.5">
        {bad ? (
          <ShieldAlert className="mt-0.5 h-7 w-7 shrink-0 text-destructive" aria-hidden="true" />
        ) : (
          <GoodCheck className="mt-0.5 h-7 w-7" />
        )}
        <div className="flex-1">
          <div className="flex items-center justify-between gap-3">
            <h4 className={`font-heading text-sm font-800 uppercase tracking-wide ${style.text}`}>
              {notice.title}
            </h4>
            <span
              data-testid="warranty-details-badge"
              className={`rounded-full border ${style.border} bg-background px-2.5 py-1 font-mono-plex text-[10px] font-600 uppercase tracking-[0.12em] ${style.text}`}
            >
              {style.badge}
            </span>
          </div>
          <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{notice.message}</p>
          {details && (
            <ul className="mt-3 grid grid-cols-1 gap-1.5 sm:grid-cols-2">
              {FIELDS.map(([key, label]) => {
                const present = !!details[key];
                return (
                  <li key={key} className="flex items-center gap-2 text-xs">
                    <span
                      className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-[4px] border-2 ${
                        present ? "border-success bg-success text-white" : "border-destructive text-destructive"
                      }`}
                      aria-hidden="true"
                    >
                      {present ? "✓" : "✕"}
                    </span>
                    <span className={present ? "text-foreground" : "text-destructive font-600"}>{label}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};
